meedy.directive('meedyAvailabilityCalendar', [ 'meedy.availabilityRuleModel', 'meedy.objectHelper', '$mdDialog',
    function (availabilityRuleModel, objectHelper, $mdDialog) {
        var definition = {
            restrict: 'E',
            scope: {
                data: '=',
                takenTerms: '=',
                criteria: '=',
                criteriaChanged: '&',
                resourceDetails: '='
            },
            templateUrl: 'meedy/application/directive/meedyAvailabilityCalendar/template/meedy-availability-calendar.html',
            link: function ($scope, element, attr) {
                $scope._availableAppointmentDates = [];
                $scope._takenTerms = [];
                $scope._revealedDaySlots = {};
                $scope._enumDaysOrder = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
                $scope._columnsData = {};
                $scope._localDateTypeEnum = {
                    FREE: 'FREE',
                    AVAILABLE: 'AVAILABLE',
                    VACATION: 'VACATION',
                    TERM: 'TERM'
                };
                $scope._dayWorkingHoursRange = {
                    start: {'hour': 6, 'minute': 0, 'second': 0, 'millisecond': 0 },
                    end: {'hour': 22, 'minute': 0, 'second': 0, 'millisecond': 0  }
                };
                $scope.displayCurrentWeek = moment($scope.today).isSame(moment($scope.criteria.startDate), 'week');

                $scope.calculateAvailabilityRuleDates = function(startDate, endDate, defaultAppointmentLength, dateType, data) {
                    if(!startDate || !endDate) { return []; }
                    var availableDates = [];
                    var appointmentLength = (defaultAppointmentLength) ? defaultAppointmentLength : 15;
                    var currentDateMoment = moment(startDate);
                    var endDateMoment = moment(endDate.getTime());
                    var endOfRuleReached = false;
                    var _dateType = (dateType) ? dateType : $scope._localDateTypeEnum.FREE;

                    while (!endOfRuleReached) {
                        var newDateMoment = currentDateMoment.clone().add((appointmentLength), 'minutes');
                        if (newDateMoment.isSameOrBefore(endDateMoment)) {
                            availableDates.push({
                                date: currentDateMoment.clone().toDate(),
                                type: _dateType,
                                data: (data) ? data : null
                            });
                            currentDateMoment = newDateMoment;
                        }
                        else {
                            endOfRuleReached = true;
                        }
                    }

                    return availableDates;
                };

                $scope.generateAppointmentDates = function(availabilities) {
                    _.forEach(availabilities, function(availabilityWrapper, idx) {
                        var _dates = [];
                        var todayMoment = moment(0, "HH");

                        if(moment(availabilityWrapper.date).isSameOrAfter(todayMoment)) {

                            availabilityWrapper.availabilities.forEach(function(currentAvailabilities) {
                                var startOfDay = (currentAvailabilities.startDate) ? currentAvailabilities.startDate : moment(availabilityWrapper.date).set($scope._dayWorkingHoursRange.start).toDate();
                                var endOfDay = (currentAvailabilities.endDate) ? currentAvailabilities.endDate : moment(availabilityWrapper.date).set($scope._dayWorkingHoursRange.end).toDate();

                                var _currAvailabilityDates = $scope.calculateAvailabilityRuleDates(startOfDay, endOfDay, currentAvailabilities.slotLength, currentAvailabilities.status, currentAvailabilities);
                                _dates = _dates.concat(_currAvailabilityDates);
                            });

                            var limitStartingIndex = _.findIndex(_dates, function(dateWrapper) {
                                return (dateWrapper.type === $scope._localDateTypeEnum.AVAILABLE)
                            });

                            $scope._columnsData[idx] = {
                                viewAll: false,
                                limitTo: 15,
                                beginIndex: (limitStartingIndex >= 0) ? limitStartingIndex : 0,
                                hideMore: false,
                                dataLength: _dates.length
                            };
                        }

                        var datesWrapper = {
                            date: availabilityWrapper.date,
                            dates: _dates
                        };

                        $scope._availableAppointmentDates.push(datesWrapper);
                    });
                };

                $scope.ensureFullWeekDataBeforeGeneratingDatesRange = function(availabilitiesWrapper) {
                    var _newAvailabilities = new Array(7);
                    var _activeDateWeek = (availabilitiesWrapper.length && availabilitiesWrapper[0].date) ? availabilitiesWrapper[0].date : new Date();
                    var _defaultAppointmentLengthToPaste = ($scope.resourceDetails) ? $scope.resourceDetails.minDefaultAppointmentLength : 10;

                    _.forEach(availabilitiesWrapper, function(availibilityWrapper) {
                        if(!availibilityWrapper.date) { return; }
                        var indexAndDayOfTheWeek = moment(availibilityWrapper.date).weekday();
                        _newAvailabilities[indexAndDayOfTheWeek] = availibilityWrapper;
                    });


                    _.forEach(_newAvailabilities, function(avail, idx) {
                        if(!avail) {
                            var _date = moment(_activeDateWeek).weekday(idx);

                            _newAvailabilities[idx] = {
                                date: _date.format(),
                                availabilities: [
                                    {
                                        startDate: null,
                                        endDate: null,
                                        slotLength: _defaultAppointmentLengthToPaste,
                                        type: $scope._localDateTypeEnum.FREE // TODO do wyrzucenia
                                    }
                                ]
                            }


                            ;
                        }
                    });

                    $scope.generateAppointmentDates(_newAvailabilities);
                };

                $scope.groupAvailabilitiesByDay = function(availabilities) {
                    var result = [];

                    if(availabilities.length) {
                        var groupedAvailabilities = _.groupBy(availabilities, function (date) {
                            return moment(date.startDate).startOf('day').format();
                        });

                        result = _.map(groupedAvailabilities, function(group, day){
                            return {
                                date: day,
                                availabilities: group
                            }
                        });
                    }

                    $scope.ensureFullWeekDataBeforeGeneratingDatesRange(result);
                };

                $scope.getDayOfTheWeek = function(date) {
                    return moment(date).day();
                };

                $scope.getDayOfTheWeekLabel = function(date) {
                    return $scope._enumDaysOrder[moment(date).day()];
                };

                $scope.getWeekAction = function(action) {
                    $scope.criteria.startDate = moment($scope.criteria.startDate)[action](1, 'week').toDate();
                    $scope.criteria.endDate = moment($scope.criteria.endDate)[action](1, 'week').toDate();
                    $scope.criteriaChanged({criteria: $scope.criteria});
                };

                $scope.showAll = function(index) {
                    $scope._columnsData[index].viewAll = !$scope._columnsData[index].viewAll;
                    $scope._columnsData[index].beginIndex = ($scope._columnsData[index].viewAll) ? 0 : $scope.findFirstOccurrenceByIndex($scope._availableAppointmentDates[index].dates);
                    if($scope._columnsData[index].beginIndex === -1) {
                        $scope._columnsData[index].beginIndex = 0;
                    }
                    $scope._columnsData[index].limitTo = ($scope._columnsData[index].viewAll) ? Infinity : 15;
                    $scope._columnsData[index].hideMore = $scope._columnsData[index].viewAll;
                };

                $scope.showMore = function(index) {
                    $scope._columnsData[index].limitTo += 15;
                    $scope._columnsData[index].hideMore = ($scope._columnsData[index].dataLength <= ($scope._columnsData[index].limitTo + $scope._columnsData[index].beginIndex));
                    $scope._columnsData[index].viewAll = $scope._columnsData[index].hideMore;
                };

                $scope.findFirstOccurrenceByIndex = function(data) {
                    return _.findIndex(data, function(dateWrapper) {
                        return (dateWrapper.type === $scope._localDateTypeEnum.AVAILABLE)
                    });
                };

                $scope.actionForTimeSlot = function (slotWrapper) {
                    if(slotWrapper.type === $scope._localDateTypeEnum.FREE || slotWrapper.type === $scope._localDateTypeEnum.VACATION) {
                        $scope.markSlotAsAvailable(slotWrapper);
                    }
                    if(slotWrapper.type === $scope._localDateTypeEnum.AVAILABLE) {
                        $scope.deleteSingleOccurence(slotWrapper);
                    }
                };

                $scope.markSlotAsAvailable = function (slotWrapper) {
                    if($scope.resourceDetails.resources.length > 1) {
                        $mdDialog.show({
                            templateUrl: 'meedy/application/directive/meedyAvailabilityCalendar/template/popup/select-resource-for-calendar-term.html',
                            controller: 'meedy.selectResourceForCalendarTermPopupController',
                            resolve: {
                                resourceDetails: function() {
                                    return $scope.resourceDetails;
                                },
                                title: function () {
                                    return 'T.MEEDY.MODULE.CALENDAR.SELECT_RESOURCE_FOR_TERM';
                                },
                                term: function() {
                                    return slotWrapper;
                                }
                            }
                        }).then(function(selectedResource) {
                            markSlot(selectedResource);
                        }, function(error){

                        });
                    }

                    if($scope.resourceDetails.resources.length === 1) {
                        markSlot($scope.resourceDetails.resources[0])
                    }

                    function markSlot(selectedResource) {

                        var slotRequestWrapper = objectHelper.o(SingleOccurrenceRequestWrapperVO, {
                            startTime: moment(slotWrapper.date).valueOf(),
                            endTime: moment(slotWrapper.date).clone().add(selectedResource.defaultAppointmentLength, 'minutes').valueOf(),
                            date: moment(slotWrapper.date).valueOf(),
                            advanced: false,
                            resource: selectedResource
                        });

                        availabilityRuleModel.createSingleOccurrence(slotRequestWrapper).then(function () {
                            slotWrapper.type = $scope._localDateTypeEnum.AVAILABLE;
                            slotWrapper.data = {
                                resource: selectedResource
                            };
                        }, function() {

                        })
                    }
                };

                $scope.deleteSingleOccurence = function (slotWrapper) {
                    var slotRequest = {
                        startDate: slotWrapper.date.getTime(),
                        endDate: moment(slotWrapper.date).clone().add(slotWrapper.data.resource.defaultAppointmentLength, 'minutes').toDate().getTime()
                    };

                    availabilityRuleModel.removeSingleOccurrence(slotWrapper.data.resource.id, slotRequest).then(function () {
                        slotWrapper.type = $scope._localDateTypeEnum.VACATION;
                    })
                };

                $scope.$watchCollection('data', function(newValue) {
                    if(newValue) {
                        $scope._availableAppointmentDates = [];
                        $scope._revealedDaySlots = {};
                        $scope._columnsData = {};
                        $scope.displayCurrentWeek = moment($scope.today).isSame(moment($scope.criteria.startDate), 'week');
                        $scope.groupAvailabilitiesByDay(newValue);
                    }
                });
            }
        };

        return definition;
    }
]);